export const iconsContainer = "ip2q9v6";
export const iconLabel = "i1fi8xkb";
export const usp = "u1ggt2dm";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");